import { GridFields } from 'components';
import { useIsFormEditable } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { Input } from 'libs/ui';
import { Field } from 'modules/operation/common/forms/operationForm';
import { formatDecimalValue } from 'modules/order/common/helpers';

import { Section } from '../../Section';

import { useParametorsSection } from './useParametorsSection';

export const ParametorsSection = () => {
  const { t } = useTranslation();

  const {
    currency,
    nominalQuantity,
    isCounterpartyNameRequired,
    isVolumeDisabled,
  } = useParametorsSection();

  const editable = useIsFormEditable();

  return (
    <Section
      datax="operation-parametorsSection"
      title={t('operation.sections.parametorsSection.title')}
    >
      <GridFields>
        <Field.Text
          disabled={editable && !isCounterpartyNameRequired}
          label={t(
            'operation.sections.parametorsSection.fields.counterpartyName.label'
          )}
          name="counterpartyName"
          placeholder={
            isCounterpartyNameRequired
              ? t(
                  'operation.sections.parametorsSection.fields.counterpartyName.placeholder'
                )
              : ''
          }
          showRequiredMark={isCounterpartyNameRequired}
        />
        <Field.Quantity
          showRequiredMark
          label={t(
            'operation.sections.parametorsSection.fields.quantity.label'
          )}
          name="quantity"
          placeholder={t(
            'operation.sections.parametorsSection.fields.quantity.placeholder'
          )}
        />
        <Input
          readOnly
          showCopyButton
          disabled={editable}
          label={t(
            'operation.sections.parametorsSection.fields.nominalQuantity.label'
          )}
          value={formatDecimalValue(nominalQuantity)}
        />
        <Input
          readOnly
          showCopyButton
          disabled={editable}
          label={t(
            'operation.sections.parametorsSection.fields.currency.label'
          )}
          value={currency}
        />
        <Field.Decimal
          showRequiredMark
          label={t(
            'operation.sections.parametorsSection.fields.netUnitPrice.label'
          )}
          maxFloatingPoints={8}
          name="netUnitPrice"
          placeholder={t(
            'operation.sections.parametorsSection.fields.netUnitPrice.placeholder'
          )}
        />
        <Field.Decimal
          label={t(
            'operation.sections.parametorsSection.fields.unitPrice.label'
          )}
          maxFloatingPoints={8}
          name="unitPrice"
          placeholder={t(
            'operation.sections.parametorsSection.fields.unitPrice.placeholder'
          )}
        />
        <Field.Decimal
          label={t(
            'operation.sections.parametorsSection.fields.accruedCouponIncome.label'
          )}
          maxFloatingPoints={8}
          name="accruedCouponIncome"
          placeholder={t(
            'operation.sections.parametorsSection.fields.accruedCouponIncome.placeholder'
          )}
        />
        <Field.Decimal
          showRequiredMark
          disabled={isVolumeDisabled}
          label={t('operation.sections.parametorsSection.fields.volume.label')}
          maxFloatingPoints={8}
          name="volume"
          placeholder={t(
            'operation.sections.parametorsSection.fields.volume.placeholder'
          )}
        />
      </GridFields>
    </Section>
  );
};
